const sessionStorageItems = {
  SOLAR_ZERO_TARGETING: 'SOLAR_ZERO_TARGETING',
  UTM_PARAMETERS: 'UTM_PARAMETERS'
}

export default sessionStorageItems
